/*       */
import { combineReducers } from 'redux';
import Immutable from 'app/utils/immutable/Immutable';

import { dataTableReducer, loadDataReducer, keepDataAtStart } from 'app/utils/redux/reducer-utils';
import {
    CREATE_WORKSPACE_STARTED,
    CREATE_WORKSPACE,
    LOAD_WORKSPACES_STARTED,
    LOAD_WORKSPACES,
    LOAD_WORKSPACE_STARTED,
    LOAD_WORKSPACE,
    LOAD_RESOURCE_LIST_STARTED,
    LOAD_RESOURCE_LIST,
    LOAD_WORKSPACE_HISTORY,
    LOAD_WORKSPACE_HISTORY_STARTED,
    LOAD_WORKSPACE_USERS_STARTED,
    LOAD_WORKSPACE_USERS,
    LOAD_WORKSPACE_RESOURCES_STARTED,
    LOAD_WORKSPACE_RESOURCES,
    LOAD_WORKSPACE_PERMISSIONS_STARTED,
    LOAD_WORKSPACE_PERMISSIONS,
    LOAD_ADDED_RESOURCE_IDS_STARTED,
    LOAD_ADDED_RESOURCE_IDS,
} from 'store/actions/admin/workspacesActions';

import avatar from './avatar/workspacesAvatarReducer';

const usersReducer = (state = { isLoading: false, data: null }, action) => {
    switch (action.type) {
        case LOAD_WORKSPACE_USERS_STARTED:
            return { ...state, isLoading: true };
        case LOAD_WORKSPACE_USERS:
            if (action.error) {
                return { ...state, isLoading: false, error: action.payload };
            }
            const newState = { ...state, isLoading: false, data: action.payload };
            return newState;
        default:
            return state;
    }
};

/**
 * Dynamic lazy resources reducer for workspace resources
 * Automatically handles any resource type without requiring pre-defined keys
 * Supports: class, entity, team, system_task, system_process, script, and any future types
 */
const lazyResourcesReducer = (state = {}, action) => {
    switch (action.type) {
        case LOAD_WORKSPACE_RESOURCES_STARTED: {
            const { resourceType } = action.meta;
            return Immutable({
                ...state,
                [resourceType]: {
                    ...(state[resourceType] || {}),
                    isLoading: true
                }
            });
        }

        case LOAD_WORKSPACE_RESOURCES: {
            const { resourceType } = action.meta;
            if (action.error) {
                return Immutable({
                    ...state,
                    [resourceType]: {
                        ...(state[resourceType] || {}),
                        isLoading: false,
                        error: action.payload
                    }
                });
            }
            return Immutable({
                ...state,
                [resourceType]: {
                    isLoading: false,
                    data: action.payload
                }
            });
        }

        default:
            return state;
    }
};

export default combineReducers({
    resourceList: dataTableReducer(LOAD_RESOURCE_LIST_STARTED, LOAD_RESOURCE_LIST, keepDataAtStart),
    list: dataTableReducer(LOAD_WORKSPACES_STARTED, LOAD_WORKSPACES, keepDataAtStart),
    details: loadDataReducer(LOAD_WORKSPACE_STARTED, LOAD_WORKSPACE),
    create: loadDataReducer(CREATE_WORKSPACE_STARTED, CREATE_WORKSPACE),
    history: dataTableReducer(LOAD_WORKSPACE_HISTORY_STARTED, LOAD_WORKSPACE_HISTORY, keepDataAtStart),
    lazyResources: lazyResourcesReducer,
    users: usersReducer,
    permissions: loadDataReducer(LOAD_WORKSPACE_PERMISSIONS_STARTED, LOAD_WORKSPACE_PERMISSIONS, keepDataAtStart),
    addedResourceIds: loadDataReducer(LOAD_ADDED_RESOURCE_IDS_STARTED, LOAD_ADDED_RESOURCE_IDS),
    avatar,
});
